//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import MComponent from '../Component';

//endregion

/** */
type Props = {
    children: ReactNode | ReactNode[];
}

/** */
class MToolbar extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <div className="grid">
                <div className="col">
                    <div className="flex justify-content-start">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );

    }

}

export default MToolbar;
